import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LayoutComponent} from '@emm/common-items/components/layout/layout.component';
import {CommonItemDetailsComponent} from '@emm/common-items/components/common-item-details/common-item-details.component';
import { CommonItemsListComponent } from './components/items/items.component';

const routes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        children: [
            {path: '', redirectTo: 'items', pathMatch: 'full'},
            {path: 'items', component: CommonItemsListComponent},
            {path: 'item-detail/:id', component: CommonItemDetailsComponent},
            {path: 'item-group-detail/:id', component: CommonItemDetailsComponent},
            {path: 'modifier-group-detail/:id', component: CommonItemDetailsComponent},
            {path: 'modifier-detail/:id', component: CommonItemDetailsComponent}
        ]
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [RouterModule]
})
export class CommonItemsRoutingModule {
}
